export default __webpack_public_path__ + "static/media/assets-film_01.6141350c.jpg";